const arrayOfYears = (years: number, startYear: number): number[] =>
  Array.from({ length: years }, (_, index) => startYear + index)
export default arrayOfYears
